import React from 'react'
import { I18n } from 'react-redux-i18n'

import { updateCurrentTab } from 'redux/smartchat/header/actions'
import AlternativesView from './AlternativesView'
import AssignmentView from './AssignmentView'
import CourtesyMessagesView from './CourtesyMessagesView'
import MessageView from './MessageView'
import OneShotProductView from './OneShotProductView'
import ProcessSearchView from './ProcessSearchView'
import ProcessSentimentView from './ProcessSentimentView'
import RandomResponsesView from './RandomResponsesView'
import SelectorView from './SelectorView'
import TimeOutView from './TimeOutView'
import VirtualAssistantView from './VirtualAssistantView'
import TextBoxView from './TextBoxView'
import { getStaticImage } from 'utils/statics'
import { languages } from 'utils/languages'
import { USER_STATES } from 'constants/index'
import FieldTextNumberView from './FieldTextNumberView'

const ActionsViewUI = ({
  currentProcess,
  actionType,
  renderType,
  previewActionRef,
  previewActionDetail,
  currentValue,
  dataForField,
  dataWay,
  onChange,
  dispatch,
  actionsErrors
}) => {
  switch (actionType) {
    case 'showAlternatives':
      return (
        <AlternativesView
          renderType={renderType}
          label={I18n.t('smartchat_events_label_showAlternatives')}
          previewActionRef={previewActionRef}
          previewActionDetail={previewActionDetail}
          dataWay={dataWay}
          error={actionsErrors[actionType]}
        />
      )
    case 'eventReassignConversation':
    case 'reassignConversation':
      return (
        <AssignmentView
          renderType={renderType}
          label={{
            assignationType: I18n.t('chatbot_events_label_assignmentType'),
            delegation: I18n.t('dashboard_assign-center'),
            operator: I18n.t('dashboard_assign-operator'),
            removeOperator: I18n.t('dashboard_unassign-operator'),
            removeAllOperators: I18n.t('dashboard_unassign-all-operators')
          }}
          placeholder={{
            assignationType: I18n.t('chatbot_events_placeholder_assignmentTypeSelect'),
            brand: I18n.t('dashboard_choose-brand'),
            delegation: I18n.t('dashboard_choose-delegation'),
            operator: I18n.t('dashboard_choose-operator')
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'COMMAND':
      return (
        <CourtesyMessagesView
          renderType={renderType}
          label={{
            message: I18n.t('dashboard_message-type'),
            petition: I18n.t('dashboard_petition')
          }}
          placeholder={{
            message: I18n.t('dashboard_choose-message'),
            petition: I18n.t('dashboard_choose-request')
          }}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'emitBotMessage':
    case 'dashboardComment':
    case 'dashboardNotification':
      return (
        <MessageView
          renderType={renderType}
          label={I18n.t('dashboard_message')}
          placeholder={I18n.t('dashboard_greeting-message-example')}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          editorOptions={actionType === 'emitBotMessage' ? ['emojis', 'attachments', 'buttons', 'preview'] : ['emojis', 'preview']}
          isNote={actionType === 'dashboardNotification' ? true : false}
          error={actionsErrors[actionType]}
        />
      )
    case 'oneShotProduct':
      return (
        <OneShotProductView
          renderType={renderType}
          label={{
            productFoundProcess: I18n.t('smartchat_events_label_productFoundProcess'),
            productNotFoundProcess: I18n.t('smartchat_events_label_productNotFoundProcess')
          }}
          placeholder={{
            productFoundProcess: I18n.t('dashboard_choose-process'),
            productNotFoundProcess: I18n.t('dashboard_choose-process')
          }}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'processCapstone':
      return (
        <ProcessSearchView
          renderType={renderType}
          label={{
            timer: I18n.t('dashboard_timeout'),
            completeProcess: I18n.t('smartchat_events_label_completeProcess'),
            partialProcess: I18n.t('smartchat_events_label_partialProcess')
          }}
          placeholder={{
            completeProcess: I18n.t('dashboard_choose-process'),
            partialProcess: I18n.t('dashboard_choose-process')
          }}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'processSentiment':
      return (
        <ProcessSentimentView
          renderType={renderType}
          label={{ sentiment: I18n.t('chatbot_events_label_sentimentType') }}
          placeholder={{ sentiment: I18n.t('dashboard_choose-feeling') }}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'emitAutoBotMessage':
      return (
        <RandomResponsesView
          renderType={renderType}
          label={I18n.t('smartchat_events_label_randomResponses')}
          placeholder={I18n.t('dashboard_choose-message-type')}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          link={{
            text: I18n.t('smartchat_events_link_randomResponses'),
            event: () => dispatch(updateCurrentTab('messages'))
          }}
          error={actionsErrors[actionType]}
        />
      )
    case 'addToManagementList':
    case 'deleteFromManagementList':
    case 'addUserToList':
    case 'removeUserFromList':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_management-list')}
          placeholder={I18n.t('dashboard_choose-management-list')}
          optionsData={{
            optionsName: ['addToManagementList', 'deleteFromManagementList'].includes(actionType)
              ? 'foldersOptions'
              : 'managementListsOptions',
            optionsParams: ['addToManagementList', 'deleteFromManagementList'].includes(actionType)
              ? { headerId: dataForField.header._id }
              : {},
            fieldName: 'managementListId'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'startProcess':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_process')}
          placeholder={I18n.t('dashboard_choose-process')}
          optionsData={{
            optionsName: 'processesOptions',
            optionsParams: { headerId: dataForField.header._id, currentProcess },
            fieldName: 'processId'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'eventChangeState':
    case 'changeState':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_state')}
          placeholder={I18n.t('dashboard_choose-state')}
          optionsData={{
            options: USER_STATES['top'].map(state => ({
              value: state,
              label: I18n.t(`states_${state}`)
            })),
            fieldName: actionType === 'changeState' ? 'actionId' : 'state'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'eventSetCategory':
    case 'eventDeleteCategory':
    case 'changeSubject':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_category')}
          placeholder={I18n.t('dashboard_choose-category')}
          optionsData={{
            optionsName: 'categoriesOptions',
            optionsParams: {},
            fieldName: actionType === 'eventSetCategory' || actionType === 'eventDeleteCategory' ? 'categoryId' : 'actionId'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'INSULT':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_insult')}
          placeholder={I18n.t('chatbot_events_placeholder_insultSelect')}
          optionsData={{
            options: [
              { value: 1, label: I18n.t('smartchat_insult_first') },
              { value: 2, label: I18n.t('smartchat_insult_second') }
            ],
            fieldName: 'repetitionNumber'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'IDK':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('chatbot_events_label_idk')}
          placeholder={I18n.t('chatbot_events_placeholder_idkSelect')}
          optionsData={{
            options: [
              { value: 1, label: I18n.t('smartchat_idk_first') },
              { value: 2, label: I18n.t('smartchat_idk_second') }
            ],
            fieldName: 'repetitionNumber'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'SUPPORT':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_petition')}
          placeholder={I18n.t('dashboard_choose-request')}
          optionsData={{
            options: [
              { value: 1, label: I18n.t('smartchat_support_first') },
              { value: 2, label: I18n.t('smartchat_support_second') }
            ],
            fieldName: 'repetitionNumber'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'CANCEL':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_petition')}
          placeholder={I18n.t('dashboard_choose-request')}
          optionsData={{
            options: [
              { value: 1, label: I18n.t('smartchat_cancel_first') },
              { value: 2, label: I18n.t('smartchat_cancel_second') }
            ],
            fieldName: 'repetitionNumber'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'UPDATE':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_petition')}
          placeholder={I18n.t('dashboard_choose-request')}
          optionsData={{
            options: [
              { value: 1, label: I18n.t('smartchat_update_first') },
              { value: 2, label: I18n.t('smartchat_update_second') }
            ],
            fieldName: 'repetitionNumber'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'eventSetLocale':
      return (
        <SelectorView
          renderType={renderType}
          label={I18n.t('dashboard_language')}
          placeholder={I18n.t('dashboard_selector_select-language')}
          optionsData={{
            options: languages.map(({ value, label }) => ({ value, label: I18n.t(label) })),
            fieldName: 'locale'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'dataEntry':
      return (
        <TextBoxView
          renderType={renderType}
          label={I18n.t('dashboard_variable-name')}
          placeholder={`${I18n.t('dashboard_type-something')}...`}
          optionsData={{
            fieldName: 'variableName'
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'botTimer':
    case 'TIMEOUT':
      return (
        <TimeOutView
          renderType={renderType}
          withPetition={actionType === 'TIMEOUT' ? true : false}
          withProcess={actionType === 'botTimer' ? true : false}
          label={{
            petition: I18n.t('dashboard_petition'),
            timer: I18n.t('dashboard_timeout'),
            process: I18n.t('dashboard_process')
          }}
          placeholder={{
            petition: I18n.t('dashboard_choose-request'),
            process: I18n.t('dashboard_choose-process')
          }}
          actionType={actionType}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          error={actionsErrors[actionType]}
        />
      )
    case 'FAQ':
      return (
        <VirtualAssistantView
          renderType={renderType}
          label={{
            virtualAssistant: I18n.t('chatbot_events_label_assistant'),
            virtualAssistantCategory: I18n.t('chatbot_events_label_faqCategory'),
            virtualAssistantFaq: I18n.t('dashboard_faq')
          }}
          placeholder={{
            virtualAssistant: I18n.t('dashboard_choose-assistant'),
            virtualAssistantCategory: I18n.t('dashboard_choose-category'),
            virtualAssistantFaq: I18n.t('dashboard_choose-faq')
          }}
          dataWay={dataWay}
          currentValue={currentValue}
          onChange={onChange}
          tooltip={{
            virtualAssistant: {
              icon: getStaticImage('/icons/orange-brand/info-circle-icon-primary.svg'),
              message: I18n.t('chatbot_events_tooltip_faqCategory')
            }
          }}
          error={actionsErrors[actionType]}
        />
      )
    case 'eventPaymentGateway':
      return (
        <>
          <TextBoxView
            renderType={renderType}
            label={I18n.t('option_concept')}
            placeholder={`${I18n.t('option_concept')}...`}
            optionsData={{
              fieldName: 'concept'
            }}
            actionType={actionType}
            dataWay={dataWay}
            currentValue={currentValue}
            onChange={onChange}
            error={actionsErrors[actionType]}
          />
          {renderType !== 'preview' &&
            <TextBoxView
              renderType={renderType}
              label={I18n.t('option_question')}
              placeholder={`${I18n.t('option_question')}...`}
              optionsData={{
                fieldName: 'question'
              }}
              actionType={actionType}
              dataWay={dataWay}
              currentValue={currentValue}
              onChange={onChange}
              error={actionsErrors[actionType]}
            />
          }
          <FieldTextNumberView
            renderType={renderType}
            label={I18n.t('option_amount')}
            placeholder={'0'}
            optionsData={{
              fieldName: 'amount'
            }}
            actionType={actionType}
            dataWay={dataWay}
            currentValue={currentValue}
            onChange={onChange}
            error={actionsErrors[actionType]}
          />
        </>
      )
    case 'GENERATIVE':
      return null
    case 'eventDeactivateMarketing':
      return null
    case 'eventActivateMarketing':
      return null
    case 'emitGenerativeResponse':
    default:
      return null
  }
}

export default ActionsViewUI
